import React from 'react';
import { CloudDownload, CloudUpload } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { getCurrentStep, Steps } from '../../Reducers/App/Selectors';
import { useSelector } from 'react-redux';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

const SaveAndLoad: React.FC = () => {
  const currentStep = useSelector(getCurrentStep);
  const showConfigurator = currentStep === Steps.CONFIGURATOR;

  const handleLoad = () => {
    Services.interaction.loadConfiguration();
  };

  const handleSave = () => {
    Services.interaction.saveConfiguration();
  };

  return (
    <>
      {showConfigurator && (
        <IconButton onClick={handleSave}>
          <CloudDownload /> <span>{t('headerMenu.save')}</span>
        </IconButton>
      )}
      <IconButton onClick={handleLoad}>
        <CloudUpload /> <span>{t('headerMenu.load')}</span>
      </IconButton>
    </>
  );
};

export default SaveAndLoad;
